(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ContentDetailController', ContentDetailController);

    ContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Content'];

    function ContentDetailController($scope, $rootScope, $stateParams, previousState, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:contentUpdate', function(event, result) {
            vm.content = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
